import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

const memberForm = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  password: "",
  confirmPassword: "",
  participateKids: 0,
  organization: "",
  role: 1,
  privateMember: 0,
  status: true,
  committees: [],
  committeesAdmin: [],
};

const committeeMemberForm = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  password: "",
  confirmPassword: "",
  participateKids: 0,
  organization: "",
  role: 0,
  privateMember: false,
  status: true,
};
// create slice
const name = "members";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const memberActions = { ...slice.actions, ...extraActions };
export const memberReducer = slice.reducer;

function createInitialState() {
  return {
    memberForm: memberForm,
    membersList: [],
    exportMembersList: [],
    createMemberResponse: {},
    updateMemberResponse: {},
    changeUserStatusResponse: {},
    getMemberByIdResponse: {},
    loading: false,

    // committee member
    committeeMemberForm: committeeMemberForm,
    membersByCommitteeList: [],
    createCommitteeMemberResponse: {},
    updateCommitteeMemberResponse: {},
    changeCommitteeMemberStatusResponse: {},
    getCommitteeMemberByIdResponse: {},
  };
}

function createReducers() {
  return {
    updateMemberForm,
    resetMemberForm,
    updateCommitteeMemberForm,
    resetCommitteeMemberForm,
  };
}

function updateMemberForm(state, action) {
  state.memberForm = action?.payload;
}

function resetMemberForm(state, action) {
  state.memberForm = memberForm;
}
function updateCommitteeMemberForm(state, action) {
  state.committeeMemberForm = { ...action.payload };
}
function resetCommitteeMemberForm(state, action) {
  state.committeeMemberForm = committeeMemberForm;
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/users`;

  return {
    getMembers: getMembers(),
    getExportMembers: getExportMembers(),
    createMember: createMember(),
    updateMember: updateMember(), //master
    changeUserStatus: changeUserStatus(),
    changeUserStatusMaster: changeUserStatusMaster(),
    getMemberById: getMemberById(),

    //committee membar api calls

    getMembersbyCommitee: getMembersbyCommitee(),
    createCommitteeMember: createCommitteeMember(),
    updateCommitteeMember: updateCommitteeMember(),
    changeCommitteeMemberStatus: changeCommitteeMemberStatus(),
    getCommitteeMemberById: getCommitteeMemberById(),
  };

  /* get member list */
  function getMembers() {
    return createAsyncThunk(
      `${name}/getMembers`,
      async (params = "") => await fetchWrapper.get(`${baseUrl}/all${params}`)
    );
  }

  function getExportMembers() {
    return createAsyncThunk(
      `${name}/getExportMembers`,
      async (params = "") => await fetchWrapper.get(`${baseUrl}/all${params}`)
    );
  }

  /* create new member */
  function createMember() {
    return createAsyncThunk(
      `${name}/createMember`,
      async (params) => await fetchWrapper.post(`${baseUrl}/createUser`, params)
    );
  }
  /* update member */
  function updateMember() {
    return createAsyncThunk(
      `${name}/updateMember`,
      async (payload) =>
        await fetchWrapper.post(
          `${baseUrl}/updateProfile/${payload?._id}`,
          payload
        )
    );
  }

  /* change usetr status */
  function changeUserStatus() {
    // return createAsyncThunk(
    //   `${name}/changeUserStatus`,
    //   async (params) =>
    //     await fetchWrapper.post(`${baseUrl}/changeUserStatus/${params?.id}`, {
    //       status: params?.status,
    //     })
    // );
    return createAsyncThunk(
      `${name}/changeUserStatusByCommittee`,
      async (params) =>
        await fetchWrapper.get(
          `${baseUrl}/changeUserStatusByCommittee/${params?.id}?committee=${params?.committee}`
        )
    );
  }

  /* change usetr status master */
  function changeUserStatusMaster() {
    return createAsyncThunk(
      `${name}/changeUserStatusMaster`,
      async (params) =>
        await fetchWrapper.get(`${baseUrl}/changeAnyUserStatus/${params?.id}`)
    );
  }

  /* get member by ID */
  function getMemberById() {
    return createAsyncThunk(
      `${name}/getMemberById`,
      async (id) => await fetchWrapper.get(`${baseUrl}/updateProfile/${id}`)
    );
  }

  // committee member api calls
  /* get members by committee */
  function getMembersbyCommitee() {
    return createAsyncThunk(
      `${name}/getMembersbyCommitee`,
      async (committeeId) =>
        // await fetchWrapper.get(`${baseUrl}/committee/${committeeId}`)
        // await fetchWrapper.get(`${baseUrl}/all?committees=${committeeId}`)
        await fetchWrapper.get(
          `${baseUrl}/all-user-by-committee?committees=${committeeId}`
        )
    );
  }

  /* create committee member */
  function createCommitteeMember() {
    return createAsyncThunk(
      `${name}/createCommitteeMember`,
      async (params) => await fetchWrapper.post(`${baseUrl}/createUser`, params)
    );
  }
  /* update committee member */
  function updateCommitteeMember() {
    return createAsyncThunk(
      `${name}/updateCommitteeMember`,
      async (payload) =>
        await fetchWrapper.post(
          `${baseUrl}/updateProfile/${payload?._id}`,
          payload
        )
    );
  }
  /* change committee member status */
  function changeCommitteeMemberStatus() {
    return createAsyncThunk(
      `${name}/changeCommitteeMemberStatus`,
      async (params) =>
        await fetchWrapper.post(
          `${baseUrl}/committee/changeStatus/${params?.id}`,
          { active: params?.status }
        )
    );
  }
  /* get committee member by ID */
  function getCommitteeMemberById() {
    return createAsyncThunk(
      `${name}/getCommitteeMemberById`,
      async (id) => await fetchWrapper.get(`${baseUrl}/updateProfile/${id}`)
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.getMembers.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getMembers.fulfilled, (state, action) => {
      state.loading = false;
      state.membersList = action?.payload;
    })
    .addCase(extraActions.getMembers.rejected, (state, action) => {
      showToastNotification(action.error.message, "error");
      state.loading = false;
      state.error = action.error;
    })
    // getExportMembers
    .addCase(extraActions.getExportMembers.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getExportMembers.fulfilled, (state, action) => {
      state.loading = false;
      state.exportMembersList = action?.payload;
    })
    .addCase(extraActions.getExportMembers.rejected, (state, action) => {
      showToastNotification(action.error.message, "error");
      state.loading = false;
      state.error = action.error;
    })

    //create new member
    .addCase(extraActions.createMember.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.createMember.fulfilled, (state, action) => {
      state.loading = false;
      state.createMemberResponse = action?.payload;
    })
    .addCase(extraActions.createMember.rejected, (state, action) => {
      showToastNotification(action.error.message, "error");
      state.loading = false;
      state.error = action.error.message;
    })

    //change user status response
    .addCase(extraActions.changeUserStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.changeUserStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.changeUserStatusResponse = action?.payload;
    })
    .addCase(extraActions.changeUserStatus.rejected, (state, action) => {
      showToastNotification(action.error.message, "error");
      state.loading = false;
      state.error = action.error;
    })

    //change master user status response
    .addCase(extraActions.changeUserStatusMaster.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.changeUserStatusMaster.fulfilled, (state, action) => {
      state.loading = false;
      state.changeUserStatusMasterResponse = action?.payload;
    })
    .addCase(extraActions.changeUserStatusMaster.rejected, (state, action) => {
      showToastNotification(action.error.message, "error");
      state.loading = false;
      state.error = action.error;
    })

    /* get membet by ID */
    .addCase(extraActions.getMemberById.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getMemberById.fulfilled, (state, action) => {
      state.loading = false;
      state.getMemberByIdResponse = action?.payload;
    })
    .addCase(extraActions.getMemberById.rejected, (state, action) => {
      showToastNotification(action.error.message, "error");
      state.loading = false;
      state.error = action.error;
    })

    //update member
    .addCase(extraActions.updateMember.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.updateMember.fulfilled, (state, action) => {
      state.loading = false;
      state.updateMemberResponse = action?.payload;
    })
    .addCase(extraActions.updateMember.rejected, (state, action) => {
      showToastNotification(action.error.message, "error");
      state.loading = false;
      state.error = action.error;
    })

    // committee member api calls
    /* get members by committee */
    .addCase(extraActions.getMembersbyCommitee.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getMembersbyCommitee.fulfilled, (state, action) => {
      state.loading = false;
      state.membersByCommitteeList = action?.payload;
    })
    .addCase(extraActions.getMembersbyCommitee.rejected, (state, action) => {
      showToastNotification(action.error.message, "error");
      state.loading = false;
      state.error = action.error;
    })

    //create committee member
    .addCase(extraActions.createCommitteeMember.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.createCommitteeMember.fulfilled, (state, action) => {
      state.loading = false;
      state.createCommitteeMemberResponse = action?.payload;
    })
    .addCase(extraActions.createCommitteeMember.rejected, (state, action) => {
      showToastNotification(action.error.message, "error");
      state.loading = false;
      state.error = action.error.message;
    })

    //change committee member status response
    .addCase(extraActions.changeCommitteeMemberStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.changeCommitteeMemberStatus.fulfilled,
      (state, action) => {
        state.loading = false;
        state.changeCommitteeMemberStatusResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.changeCommitteeMemberStatus.rejected,
      (state, action) => {
        showToastNotification(action.error.message, "error");
        state.loading = false;
        state.error = action.error;
      }
    )

    /* get committee member by ID */
    .addCase(extraActions.getCommitteeMemberById.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getCommitteeMemberById.fulfilled, (state, action) => {
      state.loading = false;
      state.getCommitteeMemberByIdResponse = action?.payload;
    })
    .addCase(extraActions.getCommitteeMemberById.rejected, (state, action) => {
      showToastNotification(action.error.message, "error");
      state.loading = false;
      state.error = action.error;
    })

    //update committee member
    .addCase(extraActions.updateCommitteeMember.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.updateCommitteeMember.fulfilled, (state, action) => {
      state.loading = false;
      state.updateCommitteeMemberResponse = action?.payload;
    })
    .addCase(extraActions.updateCommitteeMember.rejected, (state, action) => {
      showToastNotification(action.error.message, "error");
      state.loading = false;
      state.error = action.error;
    });
}
